
'use strict';

class Autocomplete {
    constructor(el) {
        this.rootEl = el;
        this.container = el.querySelector('.autocomplete');
        this.input = el.querySelector('.autocomplete .form-control');
        this.results = el.querySelector('.autocomplete .results');
        this.resultsCount = el.querySelector('.autocomplete .results-count');
        this.totalResultsFound;
        this.isExpanded = false;
        this.data = window.autocompletedata;

        this.input.addEventListener('keyup', this.handleInputKeyup.bind(this));
        this.input.addEventListener('focus', this.handleInputFocus.bind(this));

        document.body.addEventListener('click', this.handleBodyClick.bind(this));
        document.body.addEventListener('keyup', this.handleBodyKeyup.bind(this));

        this.container.addEventListener('submit', this.handleFormSubmit.bind(this));
    }

    /**
     Event handlers
    */
    handleInputKeyup(e) {
        switch (e.key) {
            case 'ArrowUp':
                e.preventDefault();

                // If listbox is expanded, move visual highlight up (or wrap around to bottom)
                if (this.isExpanded) {
                    this.highlightPreviousOption();

                    // Otherwise, populate and open the listbox, then highlight the first option
                } else {
                    this.populateResults();

                    if (this.results.children.length > 0) {
                        this.expandResults();
                    }
                }

                break;

            case 'ArrowDown':
                e.preventDefault();

                // If listbox is expanded, move visual focus down (or wrap around to top)
                if (this.isExpanded) {
                    var highlightedOption = this.rootEl.querySelector('[aria-selected="true"]');

                    if (highlightedOption != undefined) {
                        this.highlightNextOption();
                    } else {
                        this.highlightFirstOption();
                    }

                    // If listbox is NOT expanded, ensure its populated, then expand it. Also place visual focus on first option.
                } else {
                    this.populateResults();

                    if (this.results.children.length > 0) {
                        this.expandResults();
                    }
                }

                break;

            // Escape collapses the results listbox
            case 'Escape':
                if (this.isExpanded) {
                    this.collapseResults();
                }

                break;

            // Enter selects a highlighted option when results are expanded, or invokes the primary form action if collapsed
            case 'Enter':
                // If listbbox is expanded and visual focus is on an option, select that option
                var highlightedOption = this.rootEl.querySelector('[aria-selected="true"]');

                if (this.isExpanded && highlightedOption !== undefined) {
                    this.selectOption(highlightedOption);
                    this.collapseResults();
                } else {
                    if (this.input.value) {
                        this.container.submit();
                    }
                }

                break;

            // Assume all other cases are printable characters or manipulation keys
            default:
                // Only alphanumeric keys, Backspace, Delete, Tab, and some special characters (_, +, and -)
                if (/^[\b\t.a-zA-Z0-9_+-]*$/.test(String.fromCharCode(e.keyCode))) {
                    this.populateResults();

                    if (this.results.children.length > 0) {
                        if (!this.isExpanded) {
                            this.expandResults();
                        }
                    }
                }

                break;
        }
    }

    handleInputFocus(e) {
        this.populateResults();
    }

    // Collapse the results if the user clicks off the component
    handleBodyClick(e) {
        if (!this.container.contains(e.target)) {
            this.collapseResults();
        }
    }
    handleBodyKeyup(e) {
        if (e.key === 'Enter') {
            var highlightedOption = this.rootEl.querySelector('[aria-selected="true"]');

            if (this.isExpanded && highlightedOption !== undefined) {
                this.selectOption(highlightedOption);
            }
        }
    }
    handleFormSubmit(e) {
        e.preventDefault();
        var highlightedOption = this.rootEl.querySelector('[aria-selected="true"]');
        if (this.isExpanded && highlightedOption !== undefined) {
            this.selectOption(highlightedOption);
        }
        if (this.input.value) {
            this.container.submit();
        }
    }


    /**
     Results listbox visibility and manipulation
    */
    expandResults() {
        this.results.classList.add('is-visible');
        this.input.setAttribute('aria-expanded', true);
        this.isExpanded = true;
    }

    collapseResults() {
        this.results.classList.remove('is-visible');
        this.input.setAttribute('aria-expanded', false);
        this.input.removeAttribute('aria-activedescendant');
        this.resultsCount.innerHTML = '';
        this.removeHighlight();
        this.isExpanded = false;
    }


    /**
     Visual focus indication on result options
    */
    highlightFirstOption() {
        var firstOption = this.rootEl.querySelector('.autocomplete .results li:first-of-type ul li:first-of-type');
        this.highlightOption(firstOption);
    }

    highlightLastOption() {
        var lastOption = this.rootEl.querySelector('.autocomplete .results li:last-of-type li:last-of-type');
        this.highlightOption(lastOption);
    }

    highlightPreviousOption() {
        var currentOption = this.rootEl.querySelector('.autocomplete .results li li[aria-selected="true"]');
        var groups = this.rootEl.querySelectorAll('.autocomplete .results > li');
        var currentGroup = currentOption.parentElement.parentElement;
        var currentGroupOptions = currentGroup.querySelectorAll('li');
        var currentOptionIndex = Array.prototype.slice.call(currentGroupOptions).indexOf(currentOption);
        var currentGroupIndex = Array.prototype.slice.call(groups).indexOf(currentGroup);

        this.removeHighlight();

        // If there are no more options in this group, go to last option in the previous group
        if (currentOptionIndex - 1 < 0) {
            // If there are no more groups before this one, highlight the last option in the last group
            if (currentGroupIndex - 1 < 0) {
                this.highlightLastOption();

                // Otherwise, highlight the last option in the previous group
            } else {
                var previousGroupIndex = currentGroupIndex - 1;
                this.highlightOption(groups[previousGroupIndex].querySelector('li:last-of-type'));
            }

            // Otherwise, highlight the next option in this group
        } else {
            var previousOptionIndex = currentOptionIndex - 1;
            this.highlightOption(currentGroupOptions[previousOptionIndex]);
        }
    }

    highlightNextOption() {
        var currentOption = this.rootEl.querySelector('.autocomplete .results li li[aria-selected="true"]');
        var groups = this.rootEl.querySelectorAll('.autocomplete .results > li');
        var currentGroup = currentOption.parentElement.parentElement;
        var currentGroupOptions = currentGroup.querySelectorAll('li');
        var currentOptionIndex = Array.prototype.slice.call(currentGroupOptions).indexOf(currentOption);
        var currentGroupIndex = Array.prototype.slice.call(groups).indexOf(currentGroup);

        this.removeHighlight();

        // If there are no more options in this group, go to first option in the next group
        if (currentOptionIndex + 1 === currentGroupOptions.length) {
            // If there are no more groups, highlight the first option in the first group
            if (currentGroupIndex + 1 === groups.length) {
                this.highlightFirstOption();

                // Otherwise, highlight the first option in the next group
            } else {
                var nextGroupIndex = currentGroupIndex + 1;
                this.highlightOption(groups[nextGroupIndex].querySelector('li:first-of-type'));
            }

            // Otherwise, highlight the next option in this group
        } else {
            var nextOptionIndex = currentOptionIndex + 1;
            this.highlightOption(currentGroupOptions[nextOptionIndex]);
        }
    }

    highlightOption(option) {
        this.input.setAttribute('aria-activedescendant', option.getAttribute('id'));
        option.setAttribute('aria-selected', true);
    }

    removeHighlight() {
        var options = this.rootEl.querySelectorAll('.autocomplete .results li ul li');

        options.forEach(option => {
            option.removeAttribute('aria-selected');
        });
    }


    /**
     Selection of an option
    */
    selectOption(option) {
        if (option) {
            window.location = window.location.protocol + '//' + window.location.hostname + option.getAttribute('data-value');
        }
    }

    /**
     Filter data and create DOM elements for results
    */
    populateResults() {
        this.totalResultsFound = 0;
        var filteredResults = [];

        if (this.input.value) {
            // find results in all groups
            this.data.forEach((group, index) => {
                filteredResults.push({
                    name: group.name,
                    options: group.options.filter(option => {
                        return option.label.toLowerCase().includes(this.input.value.toLowerCase());
                    })
                });

                this.totalResultsFound += filteredResults[index].options.length;
            });
        } else {
            // show everything in the popular group when the this.input is blank
            this.data.forEach((group, index) => {
                if (group.name.includes('Popular')) {
                    filteredResults.push({
                        name: group.name,
                        options: group.options.filter(option => {
                            return option.label;
                        })
                    });
                } else {
                    // we still need to push the empty other groups to keep index below working
                    filteredResults.push({
                        name: group.name,
                        options: []
                    });
                }
                this.totalResultsFound += filteredResults[index].options.length;
            });
        }

        // Remove any previous results
        this.results.innerHTML = '';

        // Build and inject DOM elements for each group with options
        filteredResults.forEach((group, groupIndex) => {
            if (group.options.length === 0) {
                return;
            }

            // Create group heading and child option list
            var groupListItem = document.createElement('li');
            groupListItem.classList.add('group');
            groupListItem.setAttribute('role', 'group');
            groupListItem.setAttribute('aria-labelledby', 'group-' + groupIndex + '-heading');
            var groupTemplate = `
        <div id="group-${groupIndex}-heading" class="group-heading">${group.name}</div>
        <ul role="listbox" class="group-options" aria-describedby="group-${groupIndex}-heading"></ul>
        `;

            groupListItem.innerHTML = groupTemplate;

            // Create options within group
            var groupOptionsList = groupListItem.querySelector('ul');

            group.options.forEach((option, optionIndex) => {
                var id = 'group-' + groupIndex + '-option-' + optionIndex;

                var optionElement = document.createElement('li');
                optionElement.setAttribute('role', 'option');
                optionElement.setAttribute('id', id);
                optionElement.setAttribute('data-value', option.value);
                optionElement.classList.add('option');
                optionElement.innerHTML = option.label;

                // Move visual indicator as mouse users hover over option
                optionElement.addEventListener('mouseover', e => {
                    this.removeHighlight();
                    this.highlightOption(e.target);
                });

                // Select this option when clicked (via mouse or mouse emulation by screen readers)
                optionElement.addEventListener('click', e => {
                    this.selectOption(e.target);
                });

                groupOptionsList.appendChild(optionElement);
            });

            this.results.appendChild(groupListItem);
        });

        // Remove any previous content of the ARIA live region so that any new text added is announced, even if that new text happens to match the previous text.
        this.resultsCount.innerHTML = '';

        // Announce the number of results found to screen reader users using the ARIA live region.
        if (this.totalResultsFound > 1) {
            this.resultsCount.innerHTML = this.totalResultsFound + ' results found.';
        } else if (this.totalResultsFound === 1) {
            this.resultsCount.innerHTML = 'One result found.';
        } else {
            this.resultsCount.innerHTML = 'No results found.';
        }
    }

}

let searchFields = document.querySelectorAll(".site-search");
searchFields.forEach(el => {
    new Autocomplete(el);
});
